import React from 'react';
import './CTA.css';
import { trackCTA } from '../services/trackingService';

const CTA = () => {
    return (
        <section className="cta" aria-labelledby="cta-heading">
            <div className="container">
              <div className="cta__card">
                <div className="cta__content">
                    <h2 id="cta-heading" className="cta__title">Contactez-nous en ligne ou par téléphone</h2>
                    <p className="cta__text">Disponible de <strong>10h à 20h</strong> du <strong>lundi au jeudi</strong></p>
                </div>
                <div className="cta__actions">
                    <a href="tel:+33767428860" className="btn btn--accent cta__phone" aria-label="Appeler New School" onClick={() => trackCTA('cta_phone_call', 'CTA', 'phone_call')}>
                        <span className="cta__icon" role="img" aria-label="Téléphone">📞</span>
                        <span>+33 7 67 42 88 60</span>
                    </a>
                </div>
              </div>
            </div>
        </section>
    );
};

export default CTA;
